module.exports = __webpack_public_path__ + "img/karen-soger-2.0db72b6b.png";